

const phoneMasks = {
  "US": (value: string) => {
    const digits = value.replace(/\D/g, '');
    if (digits.length === 11 && digits.startsWith('1')) {
      return `1(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7, 11)}`;
    }
    if (digits.length <= 3) return `(${digits}`;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
  },
  "AU": (value: string) => {
    const digits = value.replace(/\D/g, '');
    if (digits.length <= 4) return digits;
    if (digits.length <= 8) return `${digits.slice(0, 4)} ${digits.slice(4)}`;
    return `${digits.slice(0, 4)} ${digits.slice(4, 8)} ${digits.slice(8, 10)}`;
  },
  "CA": (value: string) => {
    const digits = value.replace(/\D/g, '');
    if (digits.length === 11 && digits.startsWith('1')) {
      return `1(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7, 11)}`;
    }
    if (digits.length <= 3) return `(${digits}`;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
  }
};


export const phoneMask = (value: string | number, country: string = "US") => {
  const stringValue = value.toString();
  const maskFunction = phoneMasks[country as keyof typeof phoneMasks] || phoneMasks.US;
  return maskFunction(stringValue);
};
// masks.ts


/*
export const phoneMask = (value: string | number) => {
  // 1) Convert to string and strip out all non-digits.
  let digits = value.toString().replace(/\D/g, "");

  // 2) Cap to 10 digits max (area code + prefix + line number).
  if (digits.length > 10) {
    digits = digits.slice(0, 10);
  }

  // 3) If fewer than 3 digits, just open the "(" so user sees area code forming:
  //     "1"    → "(1"
  //     "12"   → "(12"
  if (digits.length < 3) {
    return "(" + digits;
  }

  // 4) If 3–5 digits, wrap the first 3 in parentheses, then a space, then the rest:
  //     "123"  → "(123) "
  //     "1234" → "(123) 4"
  //     "12345"→ "(123) 45"
  if (digits.length < 6) {
    const area = digits.slice(0, 3);
    const rest = digits.slice(3);
    return `(${area}) ${rest}`;
  }

  // 5) If 6–10 digits, split into:
  //       (123) 456-7, (123) 456-78, …, up to (123) 456-7890
  const area = digits.slice(0, 3);          // first 3
  const prefix = digits.slice(3, 6);        // next 3
  const line   = digits.slice(6, 10);       // last up to 4
  return `(${area}) ${prefix}-${line}`;
};
*/